import {
  Button,
  Modal,
  useTranslation,
  Trans,
  observer,
  useLocation,
  useSearchParams,
} from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 6223, offsets 138605:155177. Structure and names inferred from code, not screenshots.
import * as dependency98991 from "../state/cookiePreferences.js";
import * as React from "react";
import { module79457 as s } from "../vendor/dependencies.js";
import * as PlatformModule from "../config/platform.js";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as UsePageTrackingModule from "../hooks/usePageTracking.js";
import * as ClassNamesModule from "../utils/classNames.js";
import { interopDefault } from "../vendor/runtime.js";
("/", "/");
var c = interopDefault(s);
dependency98991;
let M = (e, t, i, o) => {
    let { label: label, onClick: onClick, className: className } = e;
    return (
      <Button
        key={o}
        type={o}
        onClick={onClick ?? t}
        className={(0, ClassNamesModule.cn)(
          "h-8 min-w-20 rounded-md px-3 py-[0.3125rem]",
          className,
        )}
      >
        {label}
      </Button>
    );
  },
  Component = (0, React.forwardRef)(
    (
      {
        open: open,
        onClose: onClose,
        title: title,
        subtitle: subtitle,
        showCloseButton: a = true,
        closable: r = true,
        children: children,
        footer: footer,
        primaryAction: primaryAction,
        secondaryAction: secondaryAction,
        extraActions: extraActions,
        classNames: classNames,
      },
      m,
    ) => {
      let g = onClose ?? (() => {}),
        y =
          !footer && (primaryAction || secondaryAction || extraActions?.length),
        x =
          undefined !== footer ? (
            <div>{footer}</div>
          ) : y ? (
            <div
              className={(0, ClassNamesModule.cn)(
                "flex items-center justify-end gap-3 p-6",
                classNames?.footer,
              )}
            >
              {extraActions?.map((e, t) => M(e, g, "outline", `extra-${t}`))}
              {secondaryAction && M(secondaryAction, g, "outline", "")}
              {primaryAction && M(primaryAction, undefined, "solid", "primary")}
            </div>
          ) : undefined;
      return (
        <Modal
          open={open}
          onCancel={g}
          title={""}
          footer={x}
          className={"Announcement_announcementModal__AHN0r"}
          width={620}
          centered={true}
          closable={r}
          classNames={{
            header: "hidden",
            body: (0, ClassNamesModule.cn)(
              "scrollbar-hidden flex-1 overflow-y-auto",
              classNames?.modalBody,
            ),
            content: classNames?.content,
            footer: "shrink-0",
          }}
        >
          <div ref={m} className={"flex h-full min-h-0 flex-1 flex-col"}>
            {(title || subtitle || a) && (
              <div
                className={(0, ClassNamesModule.cn)(
                  "relative p-6",
                  classNames?.header,
                )}
              >
                {(title || subtitle) && (
                  <div className={"flex flex-col items-start gap-1 pr-7"}>
                    {title && (
                      <h2
                        className={(0, ClassNamesModule.cn)(
                          "w-full select-none break-words text-base font-medium leading-6 text-mimo-text-h1-title",
                          classNames?.title,
                        )}
                      >
                        {title}
                      </h2>
                    )}
                    {subtitle && (
                      <p
                        className={(0, ClassNamesModule.cn)(
                          "w-full text-sm leading-[1.375rem] text-mimo-text-h2-caption",
                          classNames?.subtitle,
                        )}
                      >
                        {subtitle}
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
            {undefined !== children && (
              <div
                className={(0, ClassNamesModule.cn)("px-6", classNames?.body)}
              >
                {children}
              </div>
            )}
          </div>
        </Modal>
      );
    },
  );
Component.displayName = "ClawModal";
var x = "/" + "static/banner.641def5db8fe0f4e.png",
  N = "/" + "static/banner-full.541635722572ba10.png";
let Component2 = (0, React.forwardRef)(
  ({ open: open, onClose: onClose, onApply: onApply }, a) => {
    let { t: translate } = useTranslation();
    return (
      <Component
        ref={a}
        open={open}
        onClose={onClose}
        showCloseButton={false}
        closable={false}
        classNames={{
          body: "flex min-h-0 flex-1 flex-col overflow-hidden px-0",
          modalBody: "flex min-h-0 flex-1 flex-col !overflow-hidden",
          content:
            "!flex max-h-[calc(100vh-140px)] !flex-col !overflow-hidden !rounded-lg",
        }}
        primaryAction={{
          label: translate("announcement.new_model_button"),
          onClick: onApply ?? onClose,
        }}
      >
        <div
          className={
            "relative h-[10.375rem] shrink-0 overflow-hidden rounded-t-lg"
          }
        >
          <img
            src={x}
            alt={""}
            className={"h-full w-full object-cover min-[500px]:hidden"}
          />
          <img
            src={N}
            alt={""}
            className={"hidden h-full w-full object-cover min-[500px]:block"}
          />
          <button
            type={"button"}
            onClick={onClose}
            aria-label={translate("announcement.new_model_close")}
            className={
              "absolute right-[19px] top-[19px] flex h-7 w-7 items-center justify-center rounded p-1"
            }
          >
            <img
              src={
                "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJpY29uX2Nsb3NlX291dGxpbmVkIj4KPHBhdGggaWQ9IlVuaW9uIiBkPSJNMTYuODgwMyAxNi44ODAxQzE3LjIwNTggMTYuNTU0NyAxNy4yMDgxIDE2LjAyOTQgMTYuODgyNyAxNS43MDRMMTEuMTc4NyA5Ljk5OTk5TDE2Ljg4MjcgNC4yOTYwNEMxNy4yMDgxIDMuOTcwNiAxNy4yMDU3IDMuNDQ1MzIgMTYuODgwMyAzLjExOTg5QzE2LjU1NDkgMi43OTQ0NSAxNi4wMjk2IDIuNzkyMDkgMTUuNzA0MiAzLjExNzUzQzE1LjM3ODcgMy40NDI5NyAxMC4wMDAyIDguODIxNDggMTAuMDAwMiA4LjgyMTQ4TDQuMjk2MjEgMy4xMTc0OEMzLjk3MDc3IDIuNzkyMDQgMy40NDU1IDIuNzk0NCAzLjEyMDA2IDMuMTE5ODRDMi43OTQ2MiAzLjQ0NTI3IDIuNzkyMjYgMy45NzA1NSAzLjExNzcgNC4yOTU5OUw4LjgyMTcgOS45OTk5OUwzLjExNzY2IDE1LjcwNEMyLjc5MjIyIDE2LjAyOTUgMi43OTQ1OCAxNi41NTQ3IDMuMTIwMDIgMTYuODgwMkMzLjQ0NTQ1IDE3LjIwNTYgMy45NzA3MyAxNy4yMDggNC4yOTYxNyAxNi44ODI1TDEwLjAwMDIgMTEuMTc4NUwxNS43MDQyIDE2Ljg4MjVDMTYuMDI5NiAxNy4yMDc5IDE2LjU1NDkgMTcuMjA1NiAxNi44ODAzIDE2Ljg4MDFaIiBmaWxsPSIjNjQ2QTczIi8+CjwvZz4KPC9zdmc+Cg=="
              }
              alt={""}
              width={20}
              height={20}
            />
          </button>
        </div>
        <div className={"min-h-0 flex-1 overflow-y-auto"}>
          <div className={"flex flex-col gap-4 pt-6"}>
            <div className={"flex flex-col gap-px px-6"}>
              <div className={"flex items-center gap-2"}>
                <img
                  src={
                    "data:image/svg+xml;base64,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"
                  }
                  alt={""}
                  width={18}
                  height={18}
                  className={"shrink-0"}
                />
                <span
                  className={"text-sm font-medium leading-6 text-[#1F2329]"}
                >
                  {translate("announcement.new_model_section1_title")}
                </span>
              </div>
              <div className={"flex w-full flex-col gap-0.5 pl-5"}>
                <ul
                  className={
                    "m-0 list-disc pl-0 text-sm leading-6 text-[#6b6b6b]"
                  }
                >
                  <li className={"ms-[21px]"}>
                    <Trans
                      i18nKey={"announcement.new_model_pro_item"}
                      components={{
                        bold: <span className={"font-medium"} />,
                      }}
                    />
                  </li>
                  <li className={"ms-[21px]"}>
                    <Trans
                      i18nKey={"announcement.new_model_flash_item"}
                      components={{
                        bold: <span className={"font-medium"} />,
                      }}
                    />
                  </li>
                  <li className={"ms-[21px]"}>
                    <Trans
                      i18nKey={"announcement.new_model_ultraspeed_item"}
                      components={{
                        bold: <span className={"font-medium"} />,
                      }}
                    />
                  </li>
                </ul>
                <p className={"pl-1.5 text-sm leading-6 text-[#6b6b6b]"}>
                  {translate("announcement.new_model_section1_footer")}
                </p>
              </div>
            </div>
            <div className={"flex flex-col gap-px px-6"}>
              <div className={"flex items-center gap-2"}>
                <img
                  src={
                    "data:image/svg+xml;base64,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"
                  }
                  alt={""}
                  width={18}
                  height={18}
                  className={"shrink-0"}
                />
                <span
                  className={"text-sm font-medium leading-6 text-[#1F2329]"}
                >
                  {translate("announcement.new_model_section2_title")}
                </span>
              </div>
              <p className={"pl-[26px] text-sm leading-6 text-[#6b6b6b]"}>
                {translate("announcement.new_model_section2_desc")}
              </p>
            </div>
            <div className={"flex flex-col gap-px px-6"}>
              <div className={"flex items-center gap-2"}>
                <img
                  src={
                    "data:image/svg+xml;base64,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"
                  }
                  alt={""}
                  width={18}
                  height={18}
                  className={"shrink-0"}
                />
                <span
                  className={"text-sm font-medium leading-6 text-[#1F2329]"}
                >
                  {translate("announcement.new_model_section3_title")}
                </span>
              </div>
              <p className={"pl-[26px] text-sm leading-6 text-[#6b6b6b]"}>
                {translate("announcement.new_model_section3_desc")}
              </p>
            </div>
          </div>
        </div>
      </Component>
    );
  },
);
Component2.displayName = "NewModelAnnouncementModal";
let k = (e) => {
    let t = localStorage.getItem(e);
    if (t) {
      let e = c()(t);
      return e.isValid() ? e : null;
    }
    return null;
  },
  T = (e) => {
    let t = c()().format("YYYY-MM-DD");
    localStorage.setItem(e, t);
  },
  C = ({ onClose: onClose, onApply: onApply }) => {
    let { track: track } = (0, AnalyticsContext.useAnalytics)(),
      { report: report } = (0, UsePageTrackingModule.usePageTracking)(
        track,
        "global_popup_view",
        {},
        {
          reportOnUnmount: true,
          reportOnBeforeUnload: true,
        },
      );
    return (
      <Component2
        open={true}
        onClose={() => {
          (report(),
            track("track", "global_popup_close_click", {
              button: "close",
            }),
            onClose());
        }}
        onApply={onApply}
      />
    );
  };
var Announcement = observer(() => {
  let { pathname: pathname } = useLocation(),
    [t, i] = (0, React.useState)(false),
    [o] = useSearchParams(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    d = o.get("ref")?.length !== 6 && pathname.startsWith("/docs");
  return ((0, React.useEffect)(() => {
    let e = k("announce_date"),
      t = k("invite_date");
    if (d) {
      if (
        !(window.location.pathname.includes("/promotions/refer") && !t) &&
        (!e || !e.isSame(c()(), "day"))
      ) {
        (i(true), T("announce_date"));
        return;
      }
      t ||
        (PlatformModule.inviteStore.openInviteCodeModal(),
        track("track", "invite_entry_click", {
          entry_type: "announcement",
          type: "auto",
        }),
        T("invite_date"));
    }
  }, [d, track]),
  t) ? (
    <C
      onClose={() => {
        i(false);
      }}
      onApply={() => {
        (track("track", "global_popup_button_click", {
          button: "confirm",
        }),
          i(false));
      }}
    />
  ) : null;
});
export { Announcement };
